import React from 'react';

const togglePaymentMethod = (selector: string, hidden: boolean) => {
  const paymentMethodInput = document.querySelector(selector);
  if (paymentMethodInput) {
    const paymentInputFieldParent = paymentMethodInput.closest('tr');
    if (hidden) paymentInputFieldParent?.classList.add('hidden');
    else paymentInputFieldParent?.classList.remove('hidden');
  }
};

export function useCheckInvoicingStatusOnSale() {
  const [saleHasDeposit, setSaleHasDeposit] = React.useState(false);
  const [saleHasInvoicePayments, setSaleHasInvoicePayments] = React.useState(false);
  const [saleHasDepositRefunds, setSaleHasDepositRefunds] = React.useState(false);
  const [saleHasDepositPayments, setSaleHasDepositPayments] = React.useState(false);
  const [saleHasOnAccountPayment, setSaleHasOnAccountPayment] = React.useState(false);
  const [isRefundSale, setIsRefundSale] = React.useState(false);
  const [areButtonsDisabled, setAreButtonsDisabled] = React.useState(true);

  const triggerMutationObserver = () => {
    const observer = new MutationObserver(() => {
      togglePaymentMethod("input[payment_type_id='4']", false);
      togglePaymentMethod('#deposit_payment', false);

      // checks for in-person deposit on sale
      const depositWrapperElement = document.getElementById('account_deposit_row');
      if (depositWrapperElement) {
        const isTargetElHidden = window.getComputedStyle(depositWrapperElement).display === 'none';
        // if this element is hidden, then a deposit is not on the sale
        if (!isTargetElHidden) {
          setSaleHasDeposit(true);
          togglePaymentMethod("input[payment_type_id='4']", true);
          togglePaymentMethod('#deposit_payment', true);
          return;
        }

        setSaleHasDeposit(false);
      }

      // checks for invoice payment(s) on sale
      const invoicePaymentElement = document.getElementById('payment-tile');
      if (invoicePaymentElement) {
        setSaleHasInvoicePayments(true);
        togglePaymentMethod("input[payment_type_id='4']", true);
      } else setSaleHasInvoicePayments(false);

      // checks for deposit refunds on sale
      const depositRefundWrapperElement = document.getElementById('account_withdraw_row');
      if (depositRefundWrapperElement) {
        const isTargetElHidden =
          window.getComputedStyle(depositRefundWrapperElement).display === 'none';
        // if this element is hidden, then the sale does not have any deposit refunds
        setSaleHasDepositRefunds(!isTargetElHidden);
        if (!isTargetElHidden) {
          togglePaymentMethod("input[payment_type_id='4']", true);
          togglePaymentMethod('#deposit_payment', true);
        }
      }

      // checks for deposits being used as a payment method on the sale
      const depositPayment = document.getElementById('deposit_payment') as HTMLInputElement;
      if (depositPayment) {
        setSaleHasDepositPayments(!!Number(depositPayment.value));
      }

      // checks if we are in a refund on the payments screen
      const isRefund = document
        .getElementById('payments_box')
        ?.firstElementChild?.classList.contains('register-refunds');
      if (isRefund) {
        setIsRefundSale(true);
      }

      // all buttons within the component should be disabled until the payments form is loaded
      // checks if the payments form is loaded to enable the buttons
      const isPaymentsRegionLoading = document.getElementById('payments_spinner');
      if (!isPaymentsRegionLoading) {
        setAreButtonsDisabled(false);
      }

      const onAccountPaymentField = document.querySelector(
        "input[payment_type_id='4']"
      ) as HTMLInputElement;
      const hasOnAccountPayment = Number(onAccountPaymentField?.value ?? 0) > 0;
      setSaleHasOnAccountPayment(hasOnAccountPayment);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  return {
    triggerMutationObserver,
    saleHasDeposit,
    saleHasInvoicePayments,
    saleHasDepositRefunds,
    saleHasDepositPayments,
    saleHasOnAccountPayment,
    isRefundSale,
    areButtonsDisabled,
  };
}
